import { render, staticRenderFns } from "./AgentIncome.vue?vue&type=template&id=354f479a&scoped=true"
import script from "./AgentIncome.vue?vue&type=script&lang=js"
export * from "./AgentIncome.vue?vue&type=script&lang=js"
import style0 from "./AgentIncome.vue?vue&type=style&index=0&id=354f479a&prod&lang=css"
import style1 from "./AgentIncome.vue?vue&type=style&index=1&id=354f479a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354f479a",
  null
  
)

export default component.exports